/**
 * NotFoundPage — displayed for any unmatched route.
 *
 * Provides clear messaging and navigation back to the dashboard or home.
 */

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900/80 p-8 shadow-2xl text-center space-y-6">
        <p className="text-8xl font-extrabold text-slate-800">404</p>
        <h1 className="text-2xl font-extrabold text-white">Page Not Found</h1>
        <p className="text-sm text-slate-400 leading-relaxed">
          The page you are looking for doesn't exist or has been moved. Check the URL or navigate
          back to the dashboard.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/dashboard"
            className="flex-1 rounded-xl bg-blue-600 py-3 text-sm font-semibold text-white hover:bg-blue-500 transition text-center"
          >
            Return to Dashboard
          </Link>
          <Link
            to="/"
            className="flex-1 rounded-xl border border-slate-700 py-3 text-sm font-semibold text-slate-300 hover:bg-slate-800 transition text-center"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
